import { render, staticRenderFns } from "./DashboardFindings.vue?vue&type=template&id=0fbcce40"
import script from "./DashboardFindings.vue?vue&type=script&lang=ts"
export * from "./DashboardFindings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports